{
	"quantitySelector": {
		"qtySlider": "{{qty}} pcs.",
		"pcs": "pcs.",
		"maxQty": "The value exceeds the amount available in your portfolio"
	}
}
